import React from "react";

import styles from "./AddButton.module.scss";

const AddButton = ({ label, onClick = () => {} }) => {
  return (
    <button className={styles.add_btn} onClick={() => onClick()}>
      <i className="icon-plus"></i> <span>{label}</span>
    </button>
  );
};

export default AddButton;
